import { numberToCurrency } from "@/common/helpers/currency.helpers";

interface BookingInfoProps {
  valueDeposit: number;
  typePayment: string;
  valueCaucao: number;
}

export function BookingInfo({ valueDeposit, typePayment, valueCaucao }: BookingInfoProps) {
  if (valueDeposit <= 0) return null;

  return (
    <div className="bg-yellowPrimary/20 border-l-4 border-yellow-500 py-4 pl-4" role="alert">
      <p>
        O cliente já tem uma reserva paga no valor de:{" "}
        <strong><span className="text-bluePrimary">{numberToCurrency(valueDeposit)}</span></strong>
        , o método de pagamento foi: <strong><span> {typePayment} </span></strong> valor faltando para quitar o caução:{" "}
        <strong><span className="text-redPrimary">{numberToCurrency(valueCaucao)}</span></strong>
      </p>
      {typePayment === 'CREDIT_CARD' && (
        <span>
          <br />Como o método de pagamento foi crédito, o valor do caução é de
          <strong> R$650,00</strong>
        </span>
      )}
    </div>
  );
}